<template>
  <div id="app">
    <Cards />
  </div>
</template>

<script>
import Cards from './components/Cards.vue'

export default {
	name: 'cards',
	components:{
		Cards
	},
}
</script>
